module.exports = __webpack_public_path__ + "img/h_9.8f7a63b6.png";